import { DialogComponent } from "@theme/dialog";
import { CartAddEvent } from "@theme/events";

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    const autoOpenEnabled = this.hasAttribute("auto-open");
    const allowAutoOpen = this.hasAttribute("allow-auto-open");

    // Only open if auto-open setting is enabled AND we're allowed to auto-open (not on cart page)
    if (autoOpenEnabled && allowAutoOpen) {
      this.showDialog();
    }

    // Scroll cart drawer to top after item is added (especially from YMAL)
    this.#scrollToTop();
  };

  /**
   * Scrolls the cart drawer content to the top
   * Uses setTimeout to ensure DOM has been updated after morphSection completes
   */
  #scrollToTop() {
    // Wait for morphSection to complete before scrolling
    // morphSection is async, so we need to wait a bit for DOM updates
    setTimeout(() => {
      const scrollContainer =
        this.querySelector(".cart-drawer__items") ||
        this.querySelector("scroll-hint") ||
        this.querySelector(".cart-drawer__content");

      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }, 300);
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined("shopify-payment-terms").then(() => {
      const installmentsContent = document.querySelector("shopify-payment-terms")?.shadowRoot;
      const cta = installmentsContent?.querySelector("#shopify-installments-cta");
      cta?.addEventListener("click", this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get("cart-drawer-component")) {
  customElements.define("cart-drawer-component", CartDrawerComponent);
}
